export const init = async function() {
    window.nostojs((api)=>{
        api.loadRecommendations({
            placementId: 'productpage-nosto-2'
        });
    });
};
